import { FormControl } from 'react-bootstrap';

interface TextInputProps {
  label: string;
  placeholder: string;
  value: string | number | null;
  error?: string;
  onChange: (value: string | number | null) => void;
  disabled?: boolean;
  isMandatory?: boolean;
  type?: 'text' | 'number';
}

function Input({
  label,
  placeholder,
  value,
  error,
  onChange,
  disabled = false,
  isMandatory = false,
  type = 'text',
}: TextInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (type === 'number') {
      if (val === '') {
        onChange(null);
      } else {
        const num = parseFloat(val);
        onChange(isNaN(num) ? null : num);
      }
    } else {
      onChange(val);
    }
  };

  return (
    <div className="d-block w-100 subscribe__property__content__customfield">
      <div className="subscribe__property__content__label">
        {label}
        {isMandatory && <span className="text-danger"> *</span>}
      </div>
      <FormControl
        className="subscribe__property__content__input"
        type={type}
        value={value ?? ''}
        placeholder={placeholder}
        disabled={disabled}
        onChange={handleChange}
        isInvalid={!!error}
      />
      {error && (
        <div className="subscribe__property__content__error">{error}</div>
      )}
    </div>
  );
}

export default Input;
